// extracted by mini-css-extract-plugin
export default {"gauge-svg-wrapper":"gauge-svg-wrapper","gauge-desktop":"gauge-desktop","gauge-mobile":"gauge-mobile","forensic-gauge-svg":"forensic-gauge-svg"};